import { createMh } from './@mh/create-mh';
import { HIGHLIGHT_IO_PROJECT_ID } from './shared/constants';
import './shared/flat-log';
import { getGlobalFeedbackElement } from './shared/get-global-feedback-element';
import { unknownErrorToFeedback } from './shared/unknown-error-to-feedback';

const setupMonitoring = async () => {
    const highlightScript = document.createElement(`script`);
    highlightScript.src = `https://unpkg.com/highlight.run@8.12.3/dist/index.umd.js`;
    document.head.appendChild(highlightScript);
    highlightScript.onload = () => {
        (window as any).H.init(HIGHLIGHT_IO_PROJECT_ID, {
            environment: process.env[`ENVIRONMENT`],
            version: process.env[`VERSION`],
            networkRecording: {
                enabled: true,
                recordHeadersAndBody: true,
            },
        });
    };
};

const main = async () => {
    // * Global error handling wrapper.
    try {
        // * Main logic.
        setupMonitoring().catch((err) => {
            console.error(`Monitoring error occurred, session will not be monitored`, err);
        });

        window.mh = await createMh();
        import(`./@widgets`);
    } catch (err) {
        unknownErrorToFeedback(err, getGlobalFeedbackElement());
    }
};

void main();
